import { useNuxtApp } from '#imports'

import type { Locale } from '@backmarket/http-api'

import { NUXT_STATE_KEY } from '../constants'

/**
 * @returns The current locale used by the translation system.
 *
 * @example
 * const locale = useI18nLocale()
 */
export function useI18nLocale() {
  // FIXME: We should not cast the value to `Locale`. This is likely wrong
  // FIXME: since the returned value looks like `en-us`, not `en_US`.

  const nuxtApp = useNuxtApp()

  return nuxtApp.payload.state[NUXT_STATE_KEY].locale as Locale
}
